import { getRequestUrlFromRemote } from '@flex-packages/remote-core';
import { generateThumbnailRemote } from '../../apis/thumbnail/apis/thumbnail-generate-controller-api.mjs';
import { ThumbnailGenerateFallbackType } from '../../apis/thumbnail/models/thumbnail-generate-fallback-type.mjs';
import { makeImageThumbnailUrl } from './makeImageThumbnailUrl.mjs';

const QUALITY_LIST = [1, 2, 3];
function getImageSrcSet(params) {
  const { fileKey, size } = params;
  const pairs = QUALITY_LIST.map((quality) => ({
    res: `${quality}x`,
    src: makeImageThumbnailUrl({
      fileKey,
      size: size * quality
    })
  }));
  return {
    src: pairs[0]?.src || "",
    // 여기엔 다다르지 않는다.
    srcSet: pairs.map(({ res, src }) => `${src} ${res}`).join(", ")
  };
}
function getImageSrcSetWithoutNormalizeSize(params) {
  const { fileKey, size } = params;
  const pairs = QUALITY_LIST.map((quality) => ({
    res: `${quality}x`,
    src: getRequestUrlFromRemote(generateThumbnailRemote, {
      fileKey,
      size: size * quality,
      fallbackType: ThumbnailGenerateFallbackType.Original
    })
  }));
  return {
    src: pairs[0]?.src || "",
    // 여기엔 다다르지 않는다.
    srcSet: pairs.map(({ res, src }) => `${src} ${res}`).join(", ")
  };
}

export { getImageSrcSet, getImageSrcSetWithoutNormalizeSize };
//# sourceMappingURL=getImageSrcSet.mjs.map
